module.exports = __webpack_public_path__ + "img/56.maintenance_problem.e01dc1f7.svg";